import { onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useProjectNotificationsStore } from "@/v2Projects/stores/notifications";

interface UseNotificationsOptions {
  subscribeToUnreadCount?: boolean;
}

export function useNotifications(options: UseNotificationsOptions = {}) {
  const store = useProjectNotificationsStore();
  const release = store.retain(options);
  onUnmounted(release);

  const {
    notifications,
    unreadCount,
    loadError,
    viewerKey,
    listVersion,
    isReady,
    isLoadingMore,
    hasMore,
    isEnabled,
  } = storeToRefs(store);

  return {
    notifications,
    unreadCount,
    loadError,
    viewerKey,
    listVersion,
    isReady,
    isLoadingMore,
    hasMore,
    isEnabled,
    loadMore: store.loadMore,
    markRead: store.markRead,
    markUnread: store.markUnread,
    dismiss: store.dismiss,
    markAllRead: store.markAllRead,
    refresh: store.refresh,
  };
}
